import React from "react";
import { Suspense, lazy } from 'react';
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
import SkeletonL from "../Components/Skeleton/Withlogin";

const InstallmentTracker = lazy(() => import('../Components/Dashboard/InstallmentTracker/InstallmentTracker'));

const AuthInstallmentTracker = () => {
   const useAuth = () => {
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? (
    <Suspense fallback={<SkeletonL/>}>
      <InstallmentTracker/>
    </Suspense>
  ) : <SessionTimeoutRedirect />
}

export default AuthInstallmentTracker;


